import http from '@amit/composables/src/useHttp';
import { useApi } from '@amit/composables';

export const fetchGroup = group => useApi(http.get(`/groups/${group}`));

export const fetchCourseModule = ({ group, course }) =>
  useApi(http.get(`/groups/${group}/enrollments`, { params: { course } }));
